/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityMalwareDataSample } from './MonitEntityMalwareDataSample';
import {
    MonitEntityMalwareDataSampleFromJSON,
    MonitEntityMalwareDataSampleFromJSONTyped,
    MonitEntityMalwareDataSampleToJSON,
} from './MonitEntityMalwareDataSample';

/**
 * 
 * @export
 * @interface MonitEntityMalwareData
 */
export interface MonitEntityMalwareData {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMalwareData
     */
    total?: number;
    /**
     * 
     * @type {Array<MonitEntityMalwareDataSample>}
     * @memberof MonitEntityMalwareData
     */
    samples?: Array<MonitEntityMalwareDataSample>;
}

/**
 * Check if a given object implements the MonitEntityMalwareData interface.
 */
export function instanceOfMonitEntityMalwareData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityMalwareDataFromJSON(json: any): MonitEntityMalwareData {
    return MonitEntityMalwareDataFromJSONTyped(json, false);
}

export function MonitEntityMalwareDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityMalwareData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'samples': !exists(json, 'samples') ? undefined : ((json['samples'] as Array<any>).map(MonitEntityMalwareDataSampleFromJSON)),
    };
}

export function MonitEntityMalwareDataToJSON(value?: MonitEntityMalwareData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'samples': value.samples === undefined ? undefined : ((value.samples as Array<any>).map(MonitEntityMalwareDataSampleToJSON)),
    };
}

